module.exports = __webpack_public_path__ + "img/bg_001.260a82ed.png";